/*
 * @Author: caiqin.xie
 * @since: 2023-08-14 19:23:26
 * @lastTime: 2023-11-07 10:19:12
 * @LastEditors: caiqin.xie
 * @message: 配件-配件图片轮播
 */
import React, { useEffect } from "react";
import styles from "../../index.module.scss";

import loadable from 'react-loadable'
import NoSSR from 'react-no-ssr';
import LazyMedia from "@/components/LazyMedia";
const CustomSwiper = loadable({
  loader: () => import('@/components/CustomSwiper'),
  loading: () => <div></div>,
})

interface IProps {
  images: Record<string, any>[];
}

const AccessorySlider = (props:IProps) => {
  const { images} = props

  // 获取swiper实例 处理鼠标enter/leave时暂停/播放
  const [swiper, setSwiper] = React.useState<any>(null)
  useEffect(() => {
    if (swiper) {
      const swiperDom = swiper.$el[0]
      swiperDom.addEventListener('mouseenter', () => swiper.autoplay.stop())
      swiperDom.addEventListener('mouseleave', () => swiper.autoplay.start())
    }
  }, [swiper])

  return (
    <div className={styles['spare-swiper-wrap']}>
      <NoSSR>
        <CustomSwiper
          loop={(images?.length > 1) ? true : false}
          spaceBetween={24}
          swiperWrapClass={styles["custom-swiper-wrap"]}
          swiperSlideClass={styles["custom-swiper-slider"]}
          autoplay={{
            delay: 3000,
            disableOnInteraction: false,
          }}
          setSwiper={setSwiper}
          isHidePagination={false}>
          {images && images.map((item, index) => (
            <div key={item.id} className={styles['swiper-item']}>
              <div className={styles['swiper-pic']}>
                {item.extension === '.mp4' ? (
                  <LazyMedia LazyClassName={styles['swiper-img-center']} type="video" loop autoPlay preload="auto" playsInline muted src={item.url} className={styles['swiper-video']}></LazyMedia>
                ) : (
                  <LazyMedia LazyClassName={styles['swiper-img-center']} type="image"  src={item.url} className={styles['swiper-img']} alt={item.alt} />
                )}
              </div>
            </div>
          ))}
        </CustomSwiper>
      </NoSSR>
    </div>
  )
}
export default AccessorySlider
